import intlConfig from 'configuration/i18n';
import { createIntl } from 'react-intl';

const getConfiguredIntl = () => {
    return createIntl(intlConfig);
};

export default getConfiguredIntl;
